import secondaryComponents from "../../../components/secondaryComponents";
import useStaffSection from "./useStaffSection";
import styles from "./StaffSection.module.scss";
import Images from "../../../assets/images";
import React from "react";
import primaryComponents from "../../../components/primaryComponents";
import { SectionClockProvider } from "../../../components/secondaryComponents/SectionDurationBadge/SectionClockContext";
import { RoutedModal } from "../../../components/common/RoutedModal";
import { PlateIcon } from "../../../assets/svgIcons";

const GridIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <rect x="1" y="1" width="6" height="6" rx="1" />
    <rect x="9" y="1" width="6" height="6" rx="1" />
    <rect x="1" y="9" width="6" height="6" rx="1" />
    <rect x="9" y="9" width="6" height="6" rx="1" />
  </svg>
);

const ListIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <rect x="1" y="2" width="14" height="3" rx="1" />
    <rect x="1" y="7" width="14" height="3" rx="1" />
    <rect x="1" y="12" width="14" height="3" rx="1" />
  </svg>
);

const StaffSection = () => {
  const {
    isfetchingOrders,
    isFetchingNextPage,
    search,
    setDateFilter,
    autoScrollRef,
    sectionOrders,
    setSourceFilter,
    options,
    setSource,
    viewMode,
    setViewMode,
    sectionItemsCreatedEvent,
    clearSectionItemsEvent,
    sectionItemCompletedEvent,
    clearSectionItemCompletedEvent,
  } = useStaffSection();

  return (
    <SectionClockProvider>
      {/* ── section_items_created WebSocket event modal ── */}
      <RoutedModal
        isActive={!!sectionItemsCreatedEvent}
        closeModal={clearSectionItemsEvent}
        width={480}
        style={{ height: "auto" }}
        closeViaOverlay={false}
        leftHeaderSide={
          <div>
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
              <PlateIcon />
              <h4 className="mb-0">
                Queue #{sectionItemsCreatedEvent?.payload?.queue_number}
              </h4>
            </div>
            <p className="mb-0 small-text-size gray--text">
              {sectionItemsCreatedEvent?.payload?.title}
            </p>
          </div>
        }
      >
        <secondaryComponents.SectionNotificationCard
          event={sectionItemsCreatedEvent}
          onClose={clearSectionItemsEvent}
        />
      </RoutedModal>

      {/* ── section_item_completed WebSocket event modal ── */}
      <RoutedModal
        isActive={!!sectionItemCompletedEvent}
        closeModal={clearSectionItemCompletedEvent}
        width={480}
        style={{ height: "auto" }}
        closeViaOverlay={false}
        leftHeaderSide={
          <div>
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
              <PlateIcon />
              <h4 className="mb-0">
                Queue #{sectionItemCompletedEvent?.payload?.queue_number}
              </h4>
            </div>
            <p className="mb-0 small-text-size gray--text">
              {sectionItemCompletedEvent?.payload?.title}
            </p>
          </div>
        }
      >
        <secondaryComponents.SectionCompletedCard
          event={sectionItemCompletedEvent}
          onClose={clearSectionItemCompletedEvent}
        />
      </RoutedModal>

      <div className={styles.staffSection}>
        <div
          className="d-flex flex-wrap ml-auto align-items-center"
          style={{ gap: "10px" }}
        >
          <div className={styles.staffSection__viewToggle}>
            <button
              className={`${styles.staffSection__viewToggle__btn} ${viewMode === "grid" ? styles.active : ""}`}
              onClick={() => setViewMode("grid")}
              title="Grid view"
            >
              <GridIcon />
            </button>
            <button
              className={`${styles.staffSection__viewToggle__btn} ${viewMode === "list" ? styles.active : ""}`}
              onClick={() => setViewMode("list")}
              title="List view"
            >
              <ListIcon />
            </button>
          </div>

          <div style={{ width: "250px" }}>
            <primaryComponents.SelectField
              options={options}
              idKey="id"
              nameKey="name"
              value={(() => {
                if (localStorage.getItem("selectedOrderSource")) {
                  return options?.find(
                    (opt) =>
                      opt.id === localStorage.getItem("selectedOrderSource"),
                  )?.name;
                } else {
                  return "Select Order Source";
                }
              })()}
              onChange={(value) => {
                setSource(value);
                localStorage.setItem("selectedOrderSource", value);
                setSourceFilter(value);
              }}
              floatError={false}
            />
          </div>

          <primaryComponents.DateRangeInput
            startDate={search.get("start_date")}
            endDate={search.get("end_date")}
            onChange={setDateFilter}
            isToday={true}
          />
        </div>

        <secondaryComponents.LoaderHelper
          classNames={"mt-5"}
          isLoading={isfetchingOrders}
        >
          {sectionOrders?.length > 0 ? (
            <>
              <div
                className={
                  viewMode === "grid"
                    ? styles.staffSection__cards
                    : styles.staffSection__list
                }
              >
                {sectionOrders?.map((sectionOrder) => (
                  <React.Fragment key={sectionOrder?.id}>
                    {viewMode === "grid" ? (
                      <secondaryComponents.SectionCard
                        sectionOrder={sectionOrder}
                        autoScrollRef={autoScrollRef}
                      />
                    ) : (
                      <secondaryComponents.SectionCardListItem
                        sectionOrder={sectionOrder}
                        autoScrollRef={autoScrollRef}
                      />
                    )}
                  </React.Fragment>
                ))}
              </div>

              <secondaryComponents.LoaderHelper
                classNames="mt-4"
                isLoading={isFetchingNextPage && !isfetchingOrders}
              ></secondaryComponents.LoaderHelper>
            </>
          ) : (
            <div className="text-center mt-5">
              <img
                width="250px"
                height="262px"
                src={Images.storeProductEmpty}
                alt="empty state"
              />
              <h4>You haven&apos;t created an order yet </h4>
              <p>When you do, they would appear here.</p>
            </div>
          )}
        </secondaryComponents.LoaderHelper>
      </div>
    </SectionClockProvider>
  );
};

export default StaffSection;
